import IAuthenticationResponse from "../models/authentication/IAuthenticationResponse";

export function createAuthenticationResponseFromJson(json: object = {}) : IAuthenticationResponse{
  return json as IAuthenticationResponse;
}